export class SupplierWithAlias {
    id: string;
    name: string;
    alias: string = '';
    hexColorClass: string = '';
}